import React, { useState } from 'react';

import { BREAKPOINTS, useMobileBreakpoint } from '@buildoutinc/blueprint-react/hooks/use-mobile';

import MobileMenu from './mobile_menu';
import Rail from './rail';
import TopBar from './top_bar';
import { useAdminBarHeight } from './use_admin_bar_height';
import { useRailState } from './use_rail_state';
import type { OsNavProps } from './types';

import './styles.scss';

export default function OsNav({
  items,
  currentPath,
  topBar,
  profileMenu,
  tasks,
}: OsNavProps) {
  const [isExpanded, toggleRail] = useRailState();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const isMobile = useMobileBreakpoint(BREAKPOINTS.md);

  useAdminBarHeight();

  const onToggle = () => {
    if (isMobile) {
      setIsMobileOpen(!isMobileOpen);
    } else {
      toggleRail();
    }
  };

  return (
    <>
      <TopBar
        isExpanded={isExpanded}
        isMobile={isMobile}
        isMobileOpen={isMobileOpen}
        isProfileOpen={isProfileOpen}
        profileMenu={profileMenu}
        tasks={tasks}
        topBar={topBar}
        onProfileOpenChange={setIsProfileOpen}
        onToggle={onToggle}
      />

      <Rail currentPath={currentPath} isExpanded={isExpanded} items={items} />

      <MobileMenu
        currentPath={currentPath}
        isOpen={isMobileOpen}
        items={items}
        logo={topBar.logo}
        tasks={tasks}
        onOpenChange={setIsMobileOpen}
      />
    </>
  );
}
